<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-01T11:15:15+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-17T20:10:06+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card>
                    <div>
                        <span><i @click="$emit('back')" style="color: grey !important; font-size: 3rem; cursor: pointer;" class="fas fa-times text-light mb-4 me-4 pb-2"></i></span>
                        <span style=" font-size: 2rem;">
                            Distribution Request for
                            <span class="underline-heading">
                                {{data.sop_name}}
                            </span>
                        </span>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6" sm="8">
                <b-card no-body>
                    <!-- <annotate-pdf
                        v-if="b64 != null && show_document"
                        :sign_mode="false"
                        :base64="b64"/> -->
                    <div v-if="b64 != null && show_document">
                        <iframe :src="b64 + '#toolbar=0'" style="width: 100%; height: 80vh;"></iframe>
                    </div>
                    <b-alert v-else show>Waiting for document data</b-alert>
                </b-card>
            </b-col>
            <b-col cols="6" sm="4">
                <b-card title="Set Distribution Status">
                    <b-button @click="setAction('approve')" variant="success" size="lg">Approve</b-button>
                    &nbsp;
                    <b-button @click="setAction('reject')" variant="danger" size="lg">Reject</b-button>
                </b-card>
            </b-col>
        </b-row>
        <b-overlay :show="is_loading" no-wrap></b-overlay>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import { sopClientAdminMethods, layoutMethods } from "@/state/helpers"
export default {
    props:{
        data:{
            required: true,
        }
    },
    data:() => ({
        is_loading: false,
        show_document: false,
        b64: null,
        distribution_type: 'uncontrolled',
        form:{
            name: '',
            reason_text: '',
            email: '',
        }
    }),
    computed:{
        disableButton(){
            if(this.form.reason_text === '' || this.form.email === '' || this.form.name === ''){
                return true;
            }
            else{
                return false;
            }
        }
    },
    methods:{
        ...layoutMethods,
        ...sopClientAdminMethods,
        returnStyle(type){
            if(type === 'distribution_type'){
                return 'success'
            }
            else{
                return 'light'
            }
        },
        saveData(){
            let params = {
                client_revision_id: this.data.revision_id,
                copy_holder_name: this.form.name,
                copy_holder_email: this.form.email,
                reason_for_copy: this.form.reason_text,
            }
            //console.log(params);
            this.is_loading = true;
            this.distributeSOP(params)
            .then(()=>{
                this.is_loading = false;
            })
            .catch(()=>{
                this.is_loading = false;
            })
        },
        loadB64(){
            this.b64 = null;
            window.axios({
                url: 'api/clientdocadmin/b64preview/' + this.data.revision_id,
                method: 'GET',
                responseType: 'blob',
            })
            .then((response) => {
                this.b64 = window.URL.createObjectURL(response.data);
                this.show_document = true;
            }).catch(() => {
                this.show_document = false;
            });
            /*this.getPreviewB64(this.data.revision_id)
            .then( data => {
                if(data.pdf_64 != undefined){
                    this.b64 = data.pdf_64;
                    this.show_document = true;
                    //let element = document.getElementById('pdfScrollBar');
                    //element.addEventListener('scroll', this.handleScrollEvent)
                }
            })*/
        },
        setAction(type){
            let params = {
                request_id: this.data.id,
                approved: false,
                notes: '',
            }
            if(type === 'approve'){
                params.approved = true;
            }
            this.showCommentPrompt(params);
        },
        async showCommentPrompt(params){

            let title = params.approved ? 'Add Approval Note' : 'Add Rejection Note';
            //* Create Sweetalert input dialog
            const { value: note } = await Swal.fire({
                title: title,
                input: 'text',
                inputPlaceholder: 'Enter notes',
                showCancelButton: true,
            })
            if (note) {
                this.is_loading = true;
                let final_params = params;
                final_params.notes = note;
                this.approveSopDistribution(final_params)
                .then(()=>{
                    this.is_loading = false;
                    this.loadNotifications()
                    .then(()=>{
                        Swal.fire({
                            toast: true,
                            position: 'top',
                            iconColor: 'white',
                            icon: 'success',
                            title:'Set Distribution Status',
                            customClass: {     popup: 'success-toast2' },
                            showConfirmButton: false,timer: 4500,
                        });
                        this.$emit('back');
                    })
                })
            }
            else{
                this.is_loading = true;
                this.approveSopDistribution(params)
                .then(()=>{
                    this.is_loading = false;
                    this.loadNotifications()
                    .then(()=>{
                        Swal.fire({
                            toast: true,
                            position: 'top',
                            iconColor: 'white',
                            icon: 'success',
                            title:'Set Distribution Status',
                            customClass: {     popup: 'success-toast2' },
                            showConfirmButton: false,timer: 4500,
                        });
                        this.$emit('back');
                    })
                })
            }

        },
        showDistMenu(){
            this.hideMenu = false;
            this.updateMenuType({
                type: 'client_admin_distribution',
                showMenu: false,
                showRoutes: false,
            })
        },
    },
    mounted(){
        this.showDistMenu();
        this.loadB64();
    },
}
</script>

<style>

</style>
